module.exports = __webpack_public_path__ + "static/media/twitter.3251f438.svg";